import { useSelector } from 'react-redux';
import * as React from 'react';
import { selectProjectsList } from '../../selectors/projects';
import { ProjectsList } from '../../components/ProjectsList';
import { ProjectCardContainer } from '../ProjectCardContainer';
import { EmptyPageContainer } from '../EmptyPageContainer';
import { MortgageBanner } from '../../components/MortgageBanner';

const BANNER_POSITION = 5;

export const ProjectsListContainer = () => {
  const projects = useSelector(selectProjectsList);

  if (!projects.length) {
    return <EmptyPageContainer />;
  }

  const injectAfterCards = projects.length <= BANNER_POSITION;

  return (
    <>
      <ProjectsList>
        {projects.map((project, index) => {
          const isBannerPosition = index === BANNER_POSITION - 1;

          return (
            <React.Fragment key={project.id}>
              {!injectAfterCards && isBannerPosition && <MortgageBanner />}
              <ProjectCardContainer key={project.id} index={index} {...project} />
            </React.Fragment>
          );
        })}
      </ProjectsList>
      {injectAfterCards && <MortgageBanner />}
    </>
  );
};
